import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { throwIfAlreadyLoaded } from './module-import.guard';
import { NavGuard } from './nav-guard/nav.guard';
import { EyefinityGuard } from './eyefinity-guard/eyefinity.guard';
import { AuthenticationGuard } from './authentication-guard/authentication.guard';
import { AuthenticationInterceptor } from './authentication-interceptor/authentication.interceptor';
import { StatusGuard } from './status.guard';

@NgModule({
  imports: [BrowserModule, HttpClientModule],
  providers: [
    NavGuard,
    EyefinityGuard,
    AuthenticationGuard,
    AuthenticationInterceptor,
    StatusGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'Core Module');
  }
}
